import { SubscriptionStatus } from './billing'

export class Subscription implements Models.Subscription {
    id: number = 0
    user_id: number = 0
    subscription_id: string | null = ''
    status: SubscriptionStatus = SubscriptionStatus.Active
    anchor: number | null = 0
    plan_type: number | null = 0
    interval: number | null = null
    cancel_at_period_end: boolean | null = false
    trial_end: number | null = 2008592078 // unix timestamp
    overage_billing_exempt: boolean = false
    latest_overage_exemption_change: Models.SubscriptionOverageExemptionChange | null = null
    created_at: string = ''
    updated_at: string = ''

    constructor(subscription: Models.Subscription) {
        Object.assign(this, subscription)
    }

    active(): boolean {
        return this._statusIsActive(this.status) || this.hasCanceled()
    }

    inactive(): boolean {
        return !this.active()
    }

    hasCanceled(): boolean {
        return this.cancel_at_period_end && this.status === SubscriptionStatus.Active
    }

    getStatus(): string {
        switch (this.status) {
            case SubscriptionStatus.IncompleteExpired:
                return 'incomplete expired'
            case SubscriptionStatus.Incomplete:
                return 'incomplete'
            case SubscriptionStatus.Trialing:
                return 'trialing'
            case SubscriptionStatus.Active:
                return 'active'
            case SubscriptionStatus.PastDue:
                return 'past due'
            case SubscriptionStatus.Canceled:
                return 'canceled'
            case SubscriptionStatus.Unpaid:
                return 'unpaid'
            default:
                console.error('Unhandled status', this.status)
                return ''
        }
    }

    isTrialing(): boolean {
        return this.status === SubscriptionStatus.Trialing && !this.subscription_id
    }

    _statusIsActive(status: SubscriptionStatus): boolean {
        switch (status) {
            case SubscriptionStatus.Trialing:
            case SubscriptionStatus.Active:
            case SubscriptionStatus.PastDue:
                return true
            default:
                return false
        }
    }
}
